import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { SocketContext } from '../../context/SocketContext'
import { serverApi } from '../../api'

import { useHideMenu } from '../../hooks/useHideMenu'
import { useGetPantallas } from '../../hooks/useGetPantallas'
import { UseSweetAlert } from '../../hooks/useSweetAlert'
import { getUsuarioStorage } from '../../helpers/getUsuarioStorage'
import { getPendientes } from '../../helpers/gePendientes'

import { ListTicketsPendientesConsultorio } from './components/ListTicketsPendientesConsultorio';
import LoadingOverlay from '../../components/LoadingOverlay'
import { NoAcceso } from '../../components/NoAcceso'
import { NoCargaModulo } from '../../components/NoCargaModulo'
// import { SelectElement } from '../../components/selectElement2'
// import { Form } from 'react-bootstrap'
import { EditaDatosCliente } from '../ModuloAtencion/components/EditaDatosCliente'


// import logo from "../assets/logo.png";

export const ModuloConsultorio = () => {

    const usuario = useMemo(() => getUsuarioStorage(), []);
    const pantallas = useGetPantallas();
    const [modulo, setModulo] = useState(null);
    const [moduloTraslado, setModuloTraslado] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const [atencionIniciada, setAtencionIniciada] = useState(false);
    const [segundos, setSegundos] = useState(0);



    const navigate = useNavigate();
    useEffect(() => {
        if (usuario.uidUsuario === null) {
            // return <Navigate to="/ingreso" />
            navigate("/Ingreso")
        }

    }, [usuario.uidUsuario, navigate])



    useHideMenu(false);


    const { socket } = useContext(SocketContext);

    const [ticket, setTicket] = useState(null);
    const [pendientes, setPendientes] = useState([]);

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {

        const codigoEntidad = localStorage.getItem("codigoEntidad");
        const codigoUbicacion = localStorage.getItem("codigoUbicacion");

        if (!codigoEntidad || !codigoUbicacion) return;

        const fetch = async () => {
            try {

                const resp = await serverApi.post(`/modulos/select-modulos-traslado`, { codigoEntidad, codigoUbicacion });
                console.log(resp);


                const opciones = resp.data.listaModulos.map((item) => ({ value: item.uidModulo, label: ` ${item.moduloClase.toUpperCase()} - ${item.modulo.toUpperCase()} ` }))
                setModulo(opciones)



            } catch (error) {
                console.error("Error al obtener clases Modulos", error);
            } finally {

            }
        };

        fetch();

    }, [usuario])


    useEffect(() => {

        async function fetchData() {

            const formData = {
                codigoEntidad: usuario.codigoEntidad,
                uidModulo: usuario.uidModulo,
                uidUsuario: usuario.uidUsuario,
                codigoUbicacion: usuario.codigoUbicacion
            }
            try {

                const resp = await serverApi.post(`/tipos-atencion/busca-por-modulo`, formData);


                const aten = await resp.data.atenciones.filter((item) => item.checked === true);
                localStorage.setItem('tiposAtencion', aten.map((item) => item.uidTipoAtencion));

            } catch (error) {
                console.error("Error al obtener ubicaciones", error);
            }


        }

        fetchData();

    }, [usuario])


    // LLamar los tickets pendientes
    useEffect(() => {

        const getPendiente = async () => {

            const tickets = await getPendientes();
            if (!tickets) return;
            const asigndos = localStorage.getItem('tiposAtencion') === null ? [] : localStorage.getItem('tiposAtencion').split(",");
            const filteredArray = tickets.filter(item => asigndos.indexOf(item.uidTipoAtencion) >= 0);

            setPendientes(filteredArray);
        };

        getPendiente();

    }, [])

    useEffect(() => {
        if (!socket) return;

        // console.log("✅ 1. El socket ya existe. Registrando listener 'tickets-pendientes'...");

        const cargarPendientes = (pend) => {
            // Este log es la prueba de fuego: si sale, el mensaje llegó del servidor
            console.log("📩 2. ¡Mensaje recibido! Datos:", pend);

            const asignadosStr = localStorage.getItem('tiposAtencion');
            if (asignadosStr) {
                const asignados = asignadosStr.split(",");
                const filteredArray = pend.filter(item => asignados.indexOf(item.uidTipoAtencion) >= 0);

                // console.log("🔍 3. Tickets filtrados para mostrar:", filteredArray.length);
                setPendientes(filteredArray);
            } else {
                console.warn("⚠️ No hay 'tiposAtencion' en localStorage, el mensaje llegó pero no se filtró nada.");
            }
        };

        socket.on('tickets-pendientes', cargarPendientes);

        return () => {
            console.log("♻️ Limpiando listener 'tickets-pendientes'...");
            socket?.off('tickets-pendientes', cargarPendientes);
        }
    }, [socket]);

    useEffect(() => {

        let interval;
        if (atencionIniciada) {
            // Reiniciar cuando cambia el ticket
            setSegundos(0);
            interval = setInterval(() => {
                setSegundos((prev) => prev + 1);
            }, 1000);
        }

        return () => { clearInterval(interval) };

    }, [atencionIniciada]);

    const formatearTiempo = (totalSegundos) => {

        const horas = Math.floor(totalSegundos / 3600);
        const minutos = Math.floor((totalSegundos % 3600) / 60);
        const segundosRestantes = totalSegundos % 60;

        return [
            horas.toString().padStart(2, '0'),
            minutos.toString().padStart(2, '0'),
            segundosRestantes.toString().padStart(2, '0')
        ].join(':');

    };


    const volverLlamar = async (nombrePaciente, numeroTicket, uidTicketFlujo) => {

        const formData = {
            codigoEntidad: usuario.codigoEntidad,
            uidModulo: usuario.uidModulo,
            codigoUbicacion: usuario.codigoUbicacion,
            uidTicketFlujo: uidTicketFlujo
        }

        try {
            setIsLoading(true);
            const resp = await serverApi.post(`/tickets/volver-llamar`, formData);
            const ticket = resp.data;

            setIsLoading(false);

            if (ticket.ok) {
                // Actualizamos el estado con el nuevo ticket (o null si no hay más)
                console.log("Ticket actualizado: ", ticket.ticket);
            } else {
                console.error("Error al llamar ticket:", ticket.error);
            }


        } catch (error) {
            console.error("Error al obtener ubicaciones", error);
        }


    }


    const btn = useMemo(() => {

        const hayTicket = !!ticket?.uidTicketFlujo;

        return {
            siguiente: pendientes.length > 0,

            // Solo si hay ticket y aún no inició
            iniciar: hayTicket && !atencionIniciada,

            pausar: hayTicket && !atencionIniciada,

            // Solo si hay ticket y la atención inició
            rellamar: hayTicket && !atencionIniciada,
            terminar: hayTicket,

            // Solo si inició + permite traslado + módulo seleccionado
            transferir:
                hayTicket &&
                atencionIniciada &&
                ticket?.permiteTraslado === 1 &&
                !!moduloTraslado
        };

    }, [
        pendientes,
        ticket,
        atencionIniciada,
        moduloTraslado
    ]);

    const handelDataFromTable = (ticket) => {
        setTicket(ticket);
        setAtencionIniciada(false);
    }

    const iniciaAtencion = async () => {
        // 1. Evitar llamadas si ya está cargando
        if (isLoading) return;

        // 2. Obtener el ID del ticket que estamos atendiendo actualmente desde el estado
        // Si no hay ticket (primer ticket del día), mandamos null o vacío
        const ticketActualId = ticket?.uidTicketFlujo || null;

        setIsLoading(true);

        const formData = {
            codigoEntidad: usuario.codigoEntidad,
            codigoUbicacion: usuario.codigoUbicacion,
            uidModulo: usuario.uidModulo,
            uidUsuario: usuario.uidUsuario,
            agente: usuario.agente,
            uidTicketFlujo: ticketActualId
        }
        try {

            const resp = await serverApi.post(`/tickets/inicia-atencion-ticket`, formData);
            const ticket = resp.data;

            setIsLoading(false);

            if (ticket.ok) {
                setAtencionIniciada(true);

            } else {
                console.error("Error al llamar ticket:", ticket.error);
            }


        } catch (error) {
            console.error("Error al obtener ubicaciones", error);
        } finally {
            setModuloTraslado(null);
        }

    };

    const terminarTicket = async () => {

        const ticketActualId = ticket?.uidTicketFlujo || '';
        if (ticketActualId === '') {
            return UseSweetAlert('Atención!', 'No tiene Ticket cargado', 'warning')
        }

        const formData = {
            codigoEntidad: usuario.codigoEntidad,
            uidModulo: usuario.uidModulo,
            uidUsuario: usuario.uidUsuario,
            agente: usuario.agente,
            codigoUbicacion: usuario.codigoUbicacion,
            ticketAnterior: ticketActualId
        }
        try {

            setIsLoading(true);
            const resp = await serverApi.post(`/tickets/terminar-ticket`, formData);
            const ticket = resp.data;


            if (ticket.ok) {
                // Actualizamos el estado con el nuevo ticket (o null si no hay más)
                setTicket(null);
                setAtencionIniciada(false);

            } else {
                console.error("Error al llamar ticket:", ticket.error);
            }


        } catch (error) {
            console.error("Error al obtener ubicaciones", error);
        } finally {
            setModuloTraslado(null);
            setIsLoading(false)
        }
    }

    const registraDatosCliente = async (info) => {

        const codigoEntidad = usuario.codigoEntidad;
        if (!codigoEntidad || codigoEntidad === null) return UseSweetAlert('Atención!', 'Revise la infromación', 'error');


        try {

            setIsLoading(true);
            const res = await serverApi.post(
                `/tickets/registra-cliente`,
                {
                    ...info,
                    codigoEntidad,
                }
            );

            console.log(res.data);

            if (res.data.ok === false) {
                UseSweetAlert('', res.data.resp, 'error');
            } else {
                UseSweetAlert('', res.data.resp, 'success');
                setShowModal(false)
                ticket.nombrePaciente = info.nombre1?.toUpperCase() + ' ' + info.nombre2?.toUpperCase() + ' ' + info.apellido1?.toUpperCase() + ' ' + info.apellido2?.toUpperCase()
            }




        } catch (error) {
            // sweet('Atención!', res[1], 'error');
            console.error(error);
        } finally {
            setIsLoading(false);

        }



    }


    if (usuario.uidUsuario === null) {
        return (
            <>
            </>
        )
    } else if (usuario.uidModulo === null) {
        return (<NoCargaModulo />)
    }
    else if (!pantallas.includes("consultorios")) {
        return (<NoAcceso />)
    } else {

        return (
            < >
                {isLoading && <LoadingOverlay />}
                <div
                    className={`container-fluid py-3 px-3 bg-light ${isLoading ? 'opacity' : ''}`}
                    style={{ minHeight: '100vh' }}
                >
                    {/* <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3">

                        <div>
                            <h2 className="fw-bold mb-1">{usuario.modulo}</h2>

                            <div className="text-muted small">
                                {usuario.ubicacion}
                            </div>
                        </div>

                        <div className="text-end">
                            <div className="fs-1 fw-bold">
                                {new Date().toLocaleTimeString()}
                            </div>

                            <div className="text-muted">
                                {new Date().toLocaleDateString()}
                            </div>
                        </div>

                    </div> */}

                    <div className='row '>
                        {/* <div className="mt-1 col-lg-4 col-12">
                            <img id="imgPrint" style={{height:'auto',width:'100%'}} src={ logo } alt=''/>
                        </div> */}

                        {/* <div className="mt-1 col-lg-7 col-12">
                            <h2><span>{ usuario.agente }</span></h2>
                            <h4> Modulo: <span className='text-success'>{ usuario.modulo }</span> </h4>
                        </div> */}


                    </div>



                    <div
                        className="row g-3 mb-4 "
                        style={{ minHeight: 130 }}
                    >

                        {
                            pendientes?.map((item) => (

                                <div className="col-xl-2 col-md-3 col-6" key={item.uidTipoAtencion}>

                                    <div
                                        className="bg-white rounded-4 shadow-sm p-3 h-80 border"
                                        style={{ minHeight: 80 }}
                                    >

                                        <div className="d-flex align-items-center gap-1 mb-1">

                                            <div
                                                className="rounded-circle"
                                                style={{
                                                    width: 12,
                                                    height: 12,
                                                    backgroundColor: item.color
                                                }}
                                            />

                                            <div className="fw-semibold small text-truncate">
                                                {item.sigla}
                                            </div>

                                        </div>

                                        <div
                                            className="fw-bold"
                                            style={{
                                                fontSize: '2rem',
                                                color: item.color
                                            }}
                                        >
                                            {item.cantidadTickets}
                                        </div>

                                    </div>

                                </div>
                            ))
                        }

                    </div>


                    <div className="row g-4">
                        <div className="col-xl-5">
                            <div className="bg-white rounded-4 shadow-sm border p-4 h-100">

                                <div className="d-flex justify-content-between align-items-center mb-1">
                                    <h4 className="fw-bold mb-0">Atención Actual</h4>
                                    {ticket?.uidTicketFlujo && (

                                        <div className="text-center mb-1">

                                            {atencionIniciada && (
                                                <div className="text-center">

                                                    <div
                                                        style={{
                                                            fontSize: "1.4rem",
                                                            fontWeight: "bold",
                                                            color: "#FFC107",
                                                            fontFamily: "monospace"
                                                        }}
                                                    >
                                                        ⏱ {formatearTiempo(segundos)}
                                                    </div>

                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {
                                    ticket?.uidTicketFlujo ? (

                                        <div className="text-center mb-0">

                                            <button
                                                type="button"
                                                onClick={() => setShowModal(true)}
                                                className="border-0 bg-transparent p-0 text-center w-100"
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <div
                                                    className="fw-bold text-success"
                                                    style={{ fontSize: '2rem' }}
                                                >
                                                    {ticket.codigoTipoAtencion}-{ticket.numeroTicket}
                                                </div>

                                                <div className="mt-0 fs-6 fw-bold">
                                                    {ticket.numeroDocumento}
                                                    {
                                                        ticket.nombrePaciente && ticket.nombrePaciente.trim() !== '' && (
                                                            <span> - {ticket.nombrePaciente}</span>
                                                        )
                                                    }
                                                </div>

                                                <div
                                                    className="text-muted mt-0"
                                                    style={{ fontSize: 'x-small' }}
                                                >
                                                    {ticket.tipoAtencion}
                                                </div>
                                            </button>

                                        </div>

                                    ) : (

                                        <div className="text-center text-muted py-4">
                                            Sin atención activa
                                        </div>
                                    )
                                }

                                <div className="row mt-4 g-3">


                                    <div className="col-md-6">
                                        <button
                                            className="btn btn-primary w-100 fw-bold"
                                            style={{
                                                height: 60,
                                                borderRadius: 18,
                                                opacity: !btn.rellamar ? 0.4 : 1
                                            }}
                                            onClick={() => volverLlamar(
                                                ticket.nombrePaciente,
                                                ticket.numeroTicket,
                                                ticket.uidTicketFlujo
                                            )}
                                            disabled={!btn.rellamar}
                                        >
                                            Re-llamar
                                        </button>
                                    </div>

                                    <div className="col-md-6">
                                        <button
                                            className="btn btn-success w-100 fw-bold"
                                            style={{
                                                background: '#9DDFAF',
                                                height: 60,
                                                borderRadius: 18,
                                                opacity: !btn.iniciar ? 0.4 : 1
                                            }}
                                            onClick={iniciaAtencion}
                                            disabled={!btn.iniciar}

                                        >
                                            Iniciar
                                        </button>
                                    </div>


                                    <div className="col-md-12">
                                        <button
                                            className="btn btn-danger w-100 fw-bold"
                                            style={{
                                                height: 60,
                                                borderRadius: 18,
                                                opacity: !btn.terminar ? 0.4 : 1
                                            }}
                                            onClick={terminarTicket}
                                            disabled={!btn.terminar}
                                        >
                                            Terminar
                                        </button>
                                    </div>






                                </div>

                            </div>

                        </div>

                        <div className="col-xl-7">

                            <div
                                className="bg-white rounded-4 shadow-sm border p-4"
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    height: 450,
                                    overflow: 'hidden'
                                }}
                            >

                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h5 className="fw-bold mb-0">Cola de Espera</h5>

                                </div>

                                <ListTicketsPendientesConsultorio
                                    usuario={usuario}
                                    dataFromTable={handelDataFromTable}
                                    ticketActual={ticket?.uidTicketFlujo ?? null}
                                    isLoading={isLoading}
                                    setIsLoading={setIsLoading}
                                />

                            </div>

                        </div>

                    </div>



                </div>


                <EditaDatosCliente
                    show={showModal}
                    onClose={() => setShowModal(false)}
                    onSave={(datos) => registraDatosCliente(datos)}
                    ticket={ticket}
                />
            </>
        )
    }
}
